import { Component, EventEmitter, Output } from '@angular/core';
import { UserActionType } from '@piqet-angular/shared';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'piqet-angular-user-action-selection-modal',
  templateUrl: './user-action-selection-modal.component.html',
  styleUrls: ['./user-action-selection-modal.component.scss'],
})
export class UserActionSelectionModalComponent {
  @Output() actionSelected = new EventEmitter<UserActionType>();
  UserActionType = UserActionType;

  constructor(public bsModalRef: BsModalRef) {}

  selectAction(action: UserActionType) {
    this.actionSelected.emit(action);
    this.bsModalRef.hide();
  }

  onClose() {
    this.bsModalRef.hide();
  }
}
